import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=cf8b98fc&scoped=true"
import script from "./not-found.vue?vue&type=script&lang=js"
export * from "./not-found.vue?vue&type=script&lang=js"
import style0 from "./not-found.vue?vue&type=style&index=0&id=cf8b98fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8b98fc",
  null
  
)

export default component.exports